module.exports = __webpack_public_path__ + "static/media/strategies.6ef4f948.svg";